import "./Logistics.module.css";
import Header from "@/reusable_sections/Header";
import VenueDetails from "./sections/VenueDetails";
import TravelAccommodation from "./sections/TravelAccommodation";
import OnsiteServices from "./sections/OnsiteServices";
import Footer from "@/reusable_sections/Footer";
export default function LogisticsPage() {
  return <div>
      <Header />
      <VenueDetails />
      <TravelAccommodation />
      <OnsiteServices />
      <Footer />
    </div>;
}